<template>
  <div class="page pod-page">
    <section class="hero split-hero">
      <div class="hero-copy">
        <h1>POD & Dropshipping <span>Fulfillment Partner</span></h1>
        <p>
          SR Fulfill helps global ecommerce sellers source, customize, pack and ship POD
          products from China with reliable quality control and flexible fulfillment solutions.
        </p>
        <ul class="check-list">
          <li>Low MOQ</li>
          <li>Global Fulfillment</li>
          <li>US Factory Production</li>
          <li>High-End Techniques</li>
        </ul>
        <router-link class="primary-button" to="/contact_us">Get a Free Quote <span>&gt;</span></router-link>
        <div class="integration-row" aria-label="Platform integrations">
          <strong>shopify API</strong>
          <strong>Mabang</strong>
          <strong>Dianxiaomi</strong>
          <strong>YunExpress</strong>
        </div>
      </div>
      <FactoryVisual>
        <div class="video">
          <video width="100%" height="100%" muted="muted" controls autoplay="autoplay" loop="loop"
            poster="@/assets/img/shiping1.svg">
            <source src="https://cdn-madeusacustom.scsku.com/video/video2.mp4" type="video/mp4" />
            <!-- <source src="movie.ogg" type="video/ogg">
                                        <source src="movie.webm" type="video/webm"> -->
            <!-- 您的浏览器不支持 video 标签。 -->
          </video>

        </div>
      </FactoryVisual>
    </section>

    <SectionTitle title="Personalized Print on Demand Products for Your Brand" />
    <section class="product-grid">
      <article v-for="category in productCategories" :key="category.title" class="product-card card">
        <div class="title" style="display:flex; align-items: center;gap:5px;">
          <span class="number">{{ category.number }}</span>
          <h3>{{ category.title }}</h3>
        </div>
        <p>Products:</p>
        <ul>
          <li v-for="item in category.items" :key="item">{{ item }}</li>
        </ul>
        <div class="mini-products">
          <!-- <i v-for="shape in category.shapes" :key="shape" :class="shape"></i> -->
          <img v-for="(img, iIdx) in category.imgList" :key="iIdx" :src="img" :alt="img.alt" class="vi-goods-img" />
        </div>
      </article>
    </section>
    <!-- 模块三 -->
    <SectionTitle title="Print on Demand & Customization Services"
      subtitle="Turn ideas into personalized products with sourcing, branding, and fulfillment - all in one system." />
    <section>
      <icontextlist />
    </section>
    <!-- why choose us?   -->
    <section class="why-section">
      <div class="why-copy">
        <h2>Why<br>Choose Us?</h2>
        <p>Trusted by thousands of sellers worldwide. We provide the strength, scale, and service to grow with your
          business.</p>
        <router-link class="primary-button small" to="/contact_us">Get a Free Quote <span>&gt;</span></router-link>
      </div>
      <div class="stats-row">
        <article v-for="stat in stats" :key="stat.value" class="stat-card card">
          <div class="icon-bubble">{{ stat.icon }}</div>
          <strong>{{ stat.value }}</strong>
          <span>{{ stat.label }}</span>
        </article>
      </div>
      <div class="thumb-strip">
        <listImg/>
      </div>
    </section>
    <!-- end -->
    <!-- how it works?   -->
    <SectionTitle title="How it works" />
    <section class="steps-row">
      <article v-for="step in steps" :key="step.title" class="step-card card">
        <span>{{ step.number }}</span>
        <div class="icon-bubble">{{ step.icon }}</div>
        <h3>{{ step.title }}</h3>
        <p>{{ step.text }}</p>
      </article>
    </section>
  </div>
</template>

<script>
import FactoryVisual from '@/components/FactoryVisual.vue';
import SectionTitle from '@/components/SectionTitle.vue';
import img1 from "@/assets/img/index-s-1.png";
import img2 from "@/assets/img/index-s-2.png";
import img3 from "@/assets/img/index-s-3.png";
import img4 from "@/assets/img/index-s-4.png";
import icontextlist from "./components/icontextlist";
import listImg from "./components/listImg";
export default {
  name: 'Pod',
  components: {
    FactoryVisual,
    SectionTitle,
    icontextlist,
    listImg
  },
  data() {
    return {
      // 工厂图片数组
      factoryImgList: [
        { src: img1 },
        { src: img1 },
        { src: img1 },
        { src: img1 },
        { src: img1 },
      ],
      productCategories: [
        { number: '1', title: 'Apparel & Fashion', items: ['T-shirts & Hoodies', 'Streetwear & Fashion Sets', 'Bags & Caps'], imgList: [img1] },
        { number: '2', title: 'Drinkware & Daily Lifestyle', items: ['Custom drinkware', 'Jewelry Dishes'], imgList: [img2] },
        { number: '3', title: 'Gift & Personalized Item', items: ['Engraved Jewelry', 'Photo Gifts', 'Holiday Custom Gifts'], imgList: [img3] },
        { number: '4', title: 'Creative Print Products', items: ['Posters & Wall Art', 'Acrylic Prints', 'Puzzles'], imgList: [img4] }
      ],
      services: [
        { icon: 'S', title: '01 Product Sourcing', text: 'Source customizable products with 24-48h matching via China supply chain.' },
        { icon: 'T', title: '02 Custom Production', text: 'UV, laser, DTG, DTF, embroidery and more based on product type.' },
        { icon: 'B', title: '03 Personalization & Branding', text: 'Logo printing, private label and custom packaging included.' },
        { icon: 'Q', title: '04 Quality Control', text: 'Strict inspection before every shipment.' },
        { icon: 'G', title: '05 Global Fulfillment', text: 'API-synced orders with production-to-delivery tracking.' },
        { icon: '24', title: '06 24/7 Support', text: 'Order monitoring and fast issue resolution.' }
      ],
      stats: [
        { icon: '🐰', value: '10 years+', label: 'dropshipping experience' },
        { icon: '🏢', value: '5000M2+', label: 'US Factory' },
        { icon: '🛒', value: '60,000+', label: 'Orders/Day' },
        { icon: '⏱', value: '3-7 days', label: 'Production Time' },
        { icon: '📦', value: 'Full POD', label: 'Any Product, Any Process' }
      ],
      steps: [
        { number: '1', icon: 'L', title: 'You List', text: 'Add high-margin POD products to your store.' },
        { number: '2', icon: 'S', title: 'You Sell', text: 'Receive orders from your customers.' },
        { number: '3', icon: 'P', title: 'We Produce', text: 'We print, customize and package.' },
        { number: '4', icon: 'W', title: 'We Ship', text: 'Blind-ship directly to your end customers.' }
      ]
    };
  },
  methods: {
    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = 'x'// 替换为默认图片路径
    },
    toSomePage() {
      this.$router.push({
        path:"",
        query: { param1: 'value1', param2: 'value2' } // 可选的查询参数
      }); // 替换为实际的路由路径
    }
  } 
};
</script>